import axios from "axios";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';

const HeroSlider = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [sliders, setSliders] = useState([]);
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 900);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchSliders = async () => {
            try {
                const cachedSliders = localStorage.getItem('heroSlidersData');
                const cacheTimestamp = localStorage.getItem('heroSlidersDataTimestamp');
                const now = Date.now();
                const THIRTY_MINUTES = 30 * 60 * 1000;

                if (cachedSliders && cacheTimestamp && (now - parseInt(cacheTimestamp) < THIRTY_MINUTES)) {
                    setSliders(JSON.parse(cachedSliders));
                } else {
                    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
                    const Url = process.env.REACT_APP_API_SLIDERS;
                    const response = await axios.get(`${apiBaseUrl}${Url}`);

                    setSliders(response.data);
                    localStorage.setItem('heroSlidersData', JSON.stringify(response.data));
                    localStorage.setItem('heroSlidersDataTimestamp', now.toString());
                }
            } catch (error) {
                console.error("Error fetching API", error);
            }
        };

        fetchSliders();
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <Slider {...settings}>
            {sliders.map((slider, index) => (
                <div className="" key={index}>
                    <div
                        className="hero-single"
                        style={{
                            backgroundImage: `url(${backendBaseUrl}${slider?.image})`,
                            backgroundPosition: 'top center',
                            backgroundSize: isMobile ? 'contain' : 'cover',
                            backgroundRepeat: 'no-repeat',
                            height: isMobile ? 'auto' : '100vh',
                            width: '100%',
                            paddingTop: isMobile ? '0' : '120px',
                            paddingBottom: isMobile ? '0' : '180px',
                            aspectRatio: isMobile ? '16 / 9' : 'auto',
                        }}
                    >
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-12 col-lg-7">
                                    <div className="hero-content p-4">
                                        <h3
                                            className="hero-title fw-bold"
                                            data-animation="fadeInRight"
                                            data-delay=".50s"
                                            style={{
                                                color: `${slider?.heading_text_color}`,
                                                fontSize: isMobile ? '20px' : '40px',
                                            }}
                                        >
                                            {slider?.heading_text}
                                        </h3>
                                        <p
                                            data-animation="fadeInLeft"
                                            data-delay=".75s"
                                            className={'fw-bold'}
                                            style={{
                                                fontSize: isMobile ? '12px' : '25px',
                                            }}
                                        >
                                            <small style={{ color: `${slider?.body_text_color}` }}>{slider?.body_text}</small>
                                        </p>
                                        {/* Uncomment if buttons needed
                                        <div className="hero-btn" data-animation="fadeInUp" data-delay="1s">
                                            <Link className="theme-btn2 bg-primary-subtle text-dark text-decoration-none" to={'/about-us'}> About More </Link>
                                            <Link className="theme-btn2 text-decoration-none" to={'/contact-us'}> Learn More </Link>
                                        </div>
                                        */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Slider>
    );
};

export default HeroSlider;
